import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { 
  Build,
  Details,
  TrendingUp,
  Layers} from "@material-ui/icons";





import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";
import SectionCarousel from "./SectionCarousel.jsx";



class SectionService extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
       <h2 className={classes.title}>Oil & Gas Related Services</h2>
          <SectionCarousel/>

        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <div className={classes.section}>
            <h5 className={classes.description}>
              Our established team specializes 
              Offshore and onshore services, Underwater Services, NDT & ROPE ACCESSS Services, Petrochemical and Refinery industries, 
              Storage Tank Design, Process Piping Layout, 
              Process Equipment Selection, Process Exhaust System, 
              Fire Protection System Design,Lightning Protection System Design,
               Hazardous Area Classification, Central Data Control System, 
               Production-readiness Simulation, Non-destructive Testing.</h5>
               </div>
          </GridItem>
        </GridContainer>

      
          <div>
            <GridContainer>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="Offshore and onshore "
                  description="We offer Maintenance & Services for Offshore Facilities Construction, Piping Layout and fabrication, Offshore Scaffolding System Services, Crew/ Blasting and Offshore Painting and  Manpower supply."
                  icon={Build}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="Underwater Services (Diving , ROV & NTD)"
                  description="We offer Underwater Inspection in-lieu of Dry-Docking (UWILD)/ In-Water Survey (IWS)/ Underwater examination (UWE), Underwater Non-Destructive Testing,
                   Underwater Cutting/Welding, SBM Installation/Change Out, Cable/Pipe Laying, Pipe Line Maintenance, Class Approved Insert Plate (cofferdam),
                    Underwater/Subsea construction & installation, Subsea mooring, Riser installation, Underwater ship husbandry – Brush-kart, Propeller Polishing,
                     Eddy current testing, Ultrasonic Thickness Gauging, Underwater Magnetic Particle Inspection, Flooded Membrane Detection."
                  icon={Details}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
            </GridContainer>
          </div>
          <GridContainer>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="NDT & ROPE ACCESS Services"
                  description="We offer Welding Inspector, Authorized API Tank Inspector, Authorized API Pressure Tank Inspector,
                   Authorized Pressure Piping Inspector, Coating Inspector, 
                   Cathodic Protection Inspectors, Ultrasonic Testing, Surface test (Magnetic Particle Inspection and Dye Penetrant Inspection), 
                   CCTV/Boro-scope, video-scope Technicians, Corrosion monitoring C-Scan Ultrasonic, Radiography Testing, Phase Array Ultrasonic Testing."
                  icon={Layers}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="Petrochemical and Refinery industries"
                  description="We offer Conceptual Design, Front End Engineering Design (FEED), 
                  Engineering Procurement & Construction (EPC), Project Management, Plant Maintenance and Turnaround Services including Construction, 
                  Mechanical and Electrical works, Power System details design and supply MV/LV Switchgears, Power Management System (PMS) and Central Data Control System for production readiness simulation (HMI, SCADA, etc)."
                  icon={TrendingUp}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
            </GridContainer>
       
      
 <br />
  
     
      
      
          </div>  
      

          

    );
  }
}

export default withStyles(workStyle)(SectionService);



// WEBPACK FOOTER //
// ./src/views/OilPage/Sections/SectionService.jsx